import { gql } from '@apollo/client'

export const GET_VOOH_CAMPAIGN_LOCATION_FILE = gql`
  query voohCampaignLocationsFile($voohCampaignId: ID) {
    voohCampaignLocationsFile(voohCampaignId: $voohCampaignId) {
      url
    }
  }
`
